// Module
var code = "<div style=\"padding:2px;float:left\"> <div class=\"gridActionDDL\" data-bind=\"geDropDownList:{}, source:actions, onSelected:actionSelected, onOpen: onOpen, properties:{ placeHolder:'Action Items'}\"></div> </div> <jqx.grid-options-component params=\"data: gridOptionData, mainModel: $data\"></jqx.grid-options-component>";
// Exports
export default code;